import { FlexContainer, Inputs, Layout, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import FlowColLayout from 'Components/Layouts/FlowColLayout';
import CustomTransition from 'Components/CustomTransition';
import { YearsInfo } from './components/YearsInfo';
import * as Styled from './styles';

export const PreFiling = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.FILING);
  const wizardOptions = [
    { id: '1', label: t('result:Result.step.one'), value: 3 },
    { id: '2', label: t('result:Result.step.two'), value: 4 },
    { id: '3', label: t('result:Result.step.three'), value: 5 },
  ];

  return (
    <FlowColLayout section="result" isFlow>
      <CustomTransition start>
        <Layout.Wrap>
          <FlexContainer direction="column" gap="dimension_16" fullWidth fullHeight align="center">
            <FlexContainer
              direction="column"
              gap="dimension_24"
              fullWidth
              fullHeight
              align="center"
            >
              <Styled.WizardContainer align="center" justify="center">
                <Inputs.Wizard options={wizardOptions} value={4} />
              </Styled.WizardContainer>
              <FlexContainer direction="column" gap="dimension_16" fullWidth fullHeight>
                <FlexContainer direction="column" align="center" gap="dimension_08">
                  <Text type="paragraphs" color="dark" size="M_L_S">
                    {t('PreFiling.title')}
                  </Text>
                  <Text type="headline" color="dark" size="XS_L_S">
                    {t('PreFiling.description')}
                  </Text>
                </FlexContainer>
                <YearsInfo />
              </FlexContainer>
            </FlexContainer>
          </FlexContainer>
        </Layout.Wrap>
      </CustomTransition>
    </FlowColLayout>
  );
};

export default PreFiling;
